import { media } from "./media";
import { KNITTING_PATH } from "./nav";

export const FEATURE_PANEL_BG = "#2a292e";

export const FEATURE = {
  kicker: null,
  title: "Create what you couldn't before",
  desc: "From pipe coverings to monkey heads, LOOP handles the shapes that are hardest to engineer — in minutes.",
  linkLabel: "Learn how 3D knitting works",
  linkHref: KNITTING_PATH,
  image: {
    src: media("example-monkey.webp"),
    width: 1600,
    height: 1100,
    alt: "A monkey head knitted in orange and black, drawn from its knit data in LOOP's Fabric view.",
  },
} as const;
